import { invoiceIssueDate } from "./invoiceDueDate";

const money = (value) => {
  if (value == null || String(value).trim() === "") return null;
  const number = Number(String(value).replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(number) ? number : null;
};

export function invoiceMonthlyTotals(invoices) {
  const groups = new Map();
  invoices.forEach(invoice => {
    const date = invoiceIssueDate(invoice);
    if (!date) return;
    const month = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
    const amount = money(invoice.montantTTC ?? invoice.TotalTTC ?? 0);
    const ht = money(invoice.TotalHT ?? invoice.montantHT ?? invoice.totalHT);
    const group = groups.get(month) || {month, count: 0, cents: 0, htCents: 0, htCount: 0, htMissing: 0};
    group.count += 1;
    if (Number.isFinite(amount)) group.cents += Math.round(amount * 100);
    if (ht == null) group.htMissing += 1;
    else { group.htCount += 1; group.htCents += Math.round(ht * 100); }
    groups.set(month, group);
  });
  return [...groups.values()].sort((a, b) => b.month.localeCompare(a.month)).map(({cents, htCents, htCount, htMissing, ...group}) => ({
    ...group,
    amount: cents / 100,
    amountHT: htCount ? htCents / 100 : null,
    htIncomplete: htMissing > 0,
  }));
}
export const invoiceMonthLabel = month => new Date(Number(month.slice(0, 4)), Number(month.slice(5)) - 1, 1).toLocaleDateString("fr-FR", {month: "long", year: "numeric"});
